// 検索キーワードの置換（Issue #62）。wuAdminsite の SiteProductModel.SearchWordConvert（C#）を JS に写したもの。
// 旧実装は検索のたびに同期 ajax で ReplaceSearchKey を叩き、サーバーが本番 DB の ProductItemInfos を SELECT していた。
// ここでは通信なしで同じ結果を出す。判定に使う型番リストは hooks/type-codes.ts（静的 JSON）。
//
// C# の実装（順序も同じ）:
//   ① 全角英数字（Ａ-Ｚ ０-９ ａ-ｚ）の連続を半角へ（StrConv Narrow。記号・カナ・スペースは触らない）
//   ② 長音「ー」を含むなら "-" に置換したものを作り、★型番のいずれかがそれで始まるときだけ採用
//   ③ 全角ハイフン「－」も同様（②で採用済みの語に対して行う）
//
// ★★ 無条件に ー→- してはいけない。「テープ」が「テ-プ」になって検索が 0 件になる（検索ログの 56% が長音か全角ハイフンを含む）。
//   型番リストに前方一致したときだけ、が本質。向きは TypeCode.StartsWith(repkey)（型番が入力で始まる）。逆にしない。
// ★ 型番は trim も正規化もしない（先頭スペース付き「 テ-A3-1」や全角括弧付きの型番がそのまま入っている。サーバーもそのまま比較していた）。

/** ① 全角英数字だけを半角にする（U+FF21-FF3A / FF41-FF5A / FF10-FF19 → -0xFEE0）。他の全角記号は触らない */
export function narrowAlnum(src: string): string {
  return src.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (ch) => String.fromCharCode(ch.charCodeAt(0) - 0xfee0))
}

/** ②③ の出番があるか（長音か全角ハイフンを含むか）。含まなければ型番リストは要らない */
export function needsTypeCodes(src: string): boolean {
  return src.includes('ー') || src.includes('－')
}

/** 型番のいずれかが key で始まるか（C# の PickupInfos.Any(c => c.TypeCode.StartsWith(repkey))） */
export function matchesTypeCode(key: string, typeCodes: readonly string[]): boolean {
  return typeCodes.some((t) => t.startsWith(key))
}

/**
 * SearchWordConvert と同じ結果を返す。typeCodes が null（取得できなかった）のときは ①だけ行い ②③は置換しない
 * （置換しない側に倒す。旧実装は API が落ちると検索ボタンが死んでいたが、ここでは入力語のまま遷移させる）。
 */
export function convertSearchWord(src: string, typeCodes: readonly string[] | null): string {
  let s = narrowAlnum(src)
  if (typeCodes) {
    if (s.includes('ー')) {
      const rep = s.split('ー').join('-')
      if (matchesTypeCode(rep, typeCodes)) s = rep
    }
    if (s.includes('－')) {
      const rep = s.split('－').join('-')
      if (matchesTypeCode(rep, typeCodes)) s = rep
    }
  }
  return s
}
